module.exports = __webpack_public_path__ + "media/workplace/rating-dull-47621664.svg";